import reportFailureToBugsnag from '@/utilities/reportFailureToBugsnag'

function handleError (vueInstance, error) {
  reportFailureToBugsnag(error, vueInstance)
  vueInstance.paymentStore.setPaymentSuccess(false)
  vueInstance.paymentStore.setPaymentProcessing(true)
  vueInstance.paymentStore.setComplete(true)
  vueInstance.paymentStore.setPaymentResult(error)
}

async function handleSuccess (vueInstance, successPath) {
  vueInstance.paymentStore.setPaymentSuccess(true)
  vueInstance.paymentStore.setPaymentProcessing(false)
  vueInstance.paymentStore.setComplete(true)
  await vueInstance.$router.push({ name: successPath })
}

export { handleError, handleSuccess }
